import React, { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { ConfirmationModal } from 'transfix-ui/components/Modals'
import { fetchMarketplaceLoad } from 'utils/api/marketplace'
import { LOAD_STATE } from 'apps/fleet-planner/constants/loads'
import { ILoad } from 'apps/fleet-planner/types'
import { updateLoadStatus } from 'apps/fleet-planner/utils/actions/loadDetails'
import { selectLoadById } from 'apps/fleet-planner/utils/selectors'
import { IStore } from 'apps/fleet-planner/utils/types/store'

interface ISubtitleComponentDispatchModalProps {
  onClose: () => void
  open: boolean
}

export const SubtitleComponentDispatchModal: FC<ISubtitleComponentDispatchModalProps> = ({
  onClose,
  open,
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { id = '' } = useParams<{ id: string }>()
  const { pathname = '' } = useLocation()
  const load: ILoad = useSelector((state: IStore) =>
    selectLoadById(
      state,
      // strip all non-numeric value from the id
      // e.g: "TFX-", "-d", etc
      id.replace(/\D/g, '')
    )
  )
  const { externalId = '' } = load || {}
  const submitHandler = async () => {
    if (externalId) {
      const marketplaceId = externalId.replace('TFX-', '')
      const { shipment } = await fetchMarketplaceLoad(marketplaceId)
      const { status } = shipment || {}
      const { manualEta } = status || {}
      if (!manualEta) {
        const query = queryString.stringify({ id })
        // Open pickup ETA modal if there is no manual eta
        history.push(`${pathname}/update-eta?${query}`)
        return onClose()
      }
    }
    // Otherwise dispatch the shipment
    return dispatch(updateLoadStatus(load, LOAD_STATE.Dispatched))
  }
  return (
    <ConfirmationModal
      title='Dispatch load?'
      size={4}
      open={open}
      actions={[
        { label: 'Cancel', type: 'dismiss' },
        {
          label: 'Dispatch',
          type: 'confirm',
          action: submitHandler,
        },
      ]}
      onClose={onClose}>
      <p>Your driver will be notified that they&apos;ve been dispatched.</p>
    </ConfirmationModal>
  )
}
